import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const SidebarLink = styled(Box as any, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({ isActive }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '8px',
  backgroundColor: isActive ? 'var(--primary-blue)' : 'transparent',
  borderRadius: '8px',
  padding: '8px',
  height: '35px',
  width: '230px',
  boxShadow: isActive ? '0px 2px 4px rgba(0,0,0,0.1)' : 'none',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
  },
  cursor: 'pointer',
}));

export const SidebarLinkText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({ isActive }) => ({
  fontFamily: 'Outfit',
  fontWeight: isActive ? '600' : '400',
  fontSize: '14px',
  color: isActive ? 'var(--bg-color)' : 'var(--subtext)',
}));

export const SidebarIcon = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({ isActive }) => ({
  fontSize: '16px',
  color: isActive ? 'var(--bg-color)' : 'var(--subtext)',
  marginRight: '6.4px',
  marginLeft: '16px',
}));

export const SidebarContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'mobileOpen',
})<{ mobileOpen?: boolean }>(({ mobileOpen }) => ({
  width: '300px',
  backgroundColor: 'var(--inactive-btn)',
  color: 'var(--subtext)',
  height: '100%',
  position: 'fixed',
  top: 0,
  left: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  margin: 0,
  zIndex: 1200,
  transition: 'transform 0.3s ease',
  '@media (max-width: 900px)': {
    transform: mobileOpen ? 'translateX(0)' : 'translateX(-100%)',
    boxShadow: mobileOpen ? '4px 0px 10px rgba(0,0,0,0.1)' : 'none',
  },
}));

export const SidebarScrollableContent = styled(Box)({
  flexGrow: 1,
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
});

export const SidebarContentPadding = styled(Box)({
  padding: '16px',
});

export const SidebarFooter = styled(Box)({
  padding: '16px',
  marginTop: '2.4px',
});

export const SidebarDivider = styled(Box)({
  height: '1px',
  backgroundColor: 'var(--bg-color)',
  width: '90%',
  opacity: 0.5,
  marginBottom: '8px',
});

export const SidebarDropdownToggle = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})<{ isOpen?: boolean }>(({ isOpen }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px',
  height: '35px',
  width: '230px',
  borderRadius: '8px',
  cursor: 'pointer',
  marginBottom: '8px',
  backgroundColor: isOpen ? 'rgba(13, 74, 169, 0.08)' : 'transparent',
  '&:hover': {
    backgroundColor: 'rgba(13, 74, 169, 0.06)',
  },
}));

export const SidebarDropdownToggleText = styled(Typography)({
  fontFamily: 'Outfit',
  fontWeight: '600',
  fontSize: '12px',
  color: 'var(--subtext)',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  marginLeft: '16px',
});

export const SidebarDropdownArrow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})<{ isOpen?: boolean }>(({ isOpen }) => ({
  fontSize: '16px',
  color: 'var(--subtext)',
  marginRight: '8px',
  transition: 'transform 0.3s ease',
  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
}));

export const SidebarDropdownContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})<{ isOpen?: boolean }>(({ isOpen }) => ({
  maxHeight: isOpen ? '630px' : '0px',
  overflow: 'hidden',
  transition: 'max-height 0.3s ease',
}));

export const SidebarIconWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({ isActive }) => ({
  fontSize: '16px',
  color: isActive ? 'var(--primary-brand-blue)' : 'var(--bg-color)',
  marginRight: '6.4px',
  marginLeft: '16px',
}));

export const SidebarCloseIcon = styled(Box)(() => ({
  fontSize: '24px',
  color: 'var(--subtext)',
  cursor: 'pointer',
  marginRight: '16px',
  display: 'block',
  '@media (min-width: 900px)': {
    display: 'none',
  },
}));
